import { standaloneSite } from "../site-config/SiteConfig";
import { getStandaloneSpaceId } from "../standalone/config";

/** 平台站 / 独立站 订单与权益列表的数据隔离域 */
export type AccountDataScope = "platform" | "standalone";

export interface AccountListFilter {
  spaceId?: string;
  excludeSpaceIds?: string[];
}

export function resolveAccountListFilter(scope: AccountDataScope): AccountListFilter {
  const standaloneSpaceId = standaloneSite.spaceId.trim();
  if (scope === "standalone") {
    return { spaceId: getStandaloneSpaceId() };
  }
  if (standaloneSpaceId) {
    return { excludeSpaceIds: [standaloneSpaceId] };
  }
  return {};
}
